module.exports = __webpack_public_path__ + "static/img/icon_airplane_current.4fc9e509.png";